<template>
	<div>
        <Modal v-show="showCancelModal" v-on:close="gotToTheCustomerPage()">
            <template>
                <div class="text-center flex flex-column align-center">
                    <span class="margin-bottom font-primary text-wrapper" style="padding-bottom: 0px;" v-html="cancelation_text"></span>
                    <span class="margin-bottom font-primary text-wrapper">Email: <u>{{ email }}</u></span>
                    <button :disabled="showLoader" v-on:click="cancelOrder">Confirm</button>
                </div>
                
			</template>
        </Modal>
        <Loader v-show="showLoader" />
	</div>
</template>

<script>    
import Vue from 'vue'

export default {    
    data() {
        return {
            notifyShow: false,
            notify: {
                status: '',
                message: ''
            },
            showCancelModal: false,
            showLoader: false,
            cancel_info: "",
            cancelation_text: "",
            email: this.$route.params.email
        }
    },
    methods: {
        gotToTheCustomerPage() {
            this.$router.push('/customer/email/' + this.$route.params.email);
        },

        cancelOrder() {
            let params = {
                email: this.$route.params.email,
                cancel_subscription: this.cancel_info === "order_and_subscription" ? true : false
            };

            this.showCancelModal = false;
            this.showLoader = true; 
            Vue.api.post('/zendesk/orders/auto-cancel-latest', params, {
                callback: (response) => {
                    if (response && response.success) {
                        this.showCancelModal = false;
                        this.$router.push('/order/' + response.data.order_id);                        
                    } else {
                        this.showCancelModal = false;
                        this.gotToTheCustomerPage();
                    }
                },
                error: (err) => {
                    console.error("Error cancelling order", err);
                },
                errorMessage: (message) => {
                    let customMessage;
                    if (message === 'NO_STYLING_ORDER') {
                        customMessage = "No styling order found to cancel.";
                        this.gotToTheCustomerPage();
                    } else if (message === 'ORDER_ALREADY_SHIPPED') {
                        customMessage = "Cannot cancel; order has shipped.";
                        this.gotToTheCustomerPage();
                    } else if (message === 'ORDER_NOT_FOUND') {
                        customMessage = "Order not found.";
                        this.gotToTheCustomerPage();
                    } else if (message === 'ORDER_ALREADY_CANCELLED') {
                        customMessage = "Order already cancelled.";
                        this.gotToTheCustomerPage();
                    }  else if (message === 'ORDER_NOT_CANCELLED_IN_WAREHOUSE') {
                        customMessage = "Cannot cancel; order has been pushed to warehouse (contact Logistics Coordinator).";
                        this.gotToTheCustomerPage();
                    } else if (message === 'CUSTOMER_NOT_FOUND') {
                        customMessage = "No matching profile found.";
                    }  else {
                        customMessage = "Something went wrong. Try again.";
                        this.showCancelModal = true;
                    }
                    alert(customMessage);
                },
                always: () => {
                   this.showLoader = false;
                }
            });
        },
    },
    created() {
        if (this.$route.path.includes('/cancel_order_and_sub/')) {
            this.cancel_info = "order_and_subscription";
            this.cancelation_text = "Cancel both the order and the subscription?";
        } else if (this.$route.path.includes('/cancel_order/')) {
            this.cancel_info = "order";
            this.cancelation_text = "Cancel the customer's order? <br> This removes products from the order.";
        }

        this.showCancelModal = true;
    }
}
</script>

<style lang="less" scoped>  
.notify-wrapper {
  position: absolute;
  right: 0;
  top: 20px;
  background: rgba(255, 255, 255, 0.6);
  padding: 10px;
  border-radius: 5px;
  z-index: 99;
  flex-direction: column;
}

.text-wrapper{
    font-size: 18px;
    font-weight: 400;
    color: #2b2b2be0;
    text-align: center;
    line-height: 1.5;
    max-width: 400px;
    margin: 0 auto;
    padding-bottom: 30px;
}

::v-deep .modal .modal-content {
    overflow-y: auto;
}
</style>